import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _3gMobiledataIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"3g_mobiledata"} ref={ref}/>
});

_3gMobiledataIcon.displayName = "_3gMobiledataIcon";
